import React from 'react';
import './Contact.css';

import { 
  FaPhone, 
  FaEnvelope, 
  FaUser, 
  FaPaperPlane,
  FaComments,
  FaMapMarkerAlt,
  FaQuestionCircle
} from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="contact-container">
      <div className="hero-section">
        <div className="hero-background-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
        <div className="hero-content">
          <h1><FaComments className="hero-icon" />Get in Touch</h1>
          <p className="hero-subtitle">
            Have questions about the event, registration, or sponsorships? Reach out to us!
          </p>
        </div>
      </div>
      
      <div className="info-card">
        <FaUser className="card-icon" />
        <div className="card-content">
          <h2>Contact Information</h2>
          <div className="contact-info-grid">
            <div className="contact-item">
              <FaUser className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Event Organizer</span>
                <span className="contact-value">Moises Segovia</span>
              </div>
            </div>
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Phone</span>
                <a href="tel:956-588-8168" className="contact-value phone-link">
                  (956) 588-8168
                </a>
              </div>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Email</span>
                <a href="mailto:moisessegovia588@gmail.com" className="contact-value email-link">
                  moisessegovia588@gmail.com
                </a>
              </div>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <div className="contact-details">
                <span className="contact-label">Event Location</span>
                <span className="contact-value">Hidalgo County Sheriff's Posse Arena, Edinburg, TX</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="info-card form-card">
        <FaPaperPlane className="card-icon" />
        <div className="card-content">
          <h2>Send Us a Message</h2>
          <form className="contact-form">
            <div className="form-group">
              <label htmlFor="name">
                <FaUser className="label-icon" />
                Name
              </label>
              <input type="text" id="name" name="name" required placeholder="Your full name" />
            </div>
            <div className="form-group">
              <label htmlFor="email">
                <FaEnvelope className="label-icon" />
                Email
              </label>
              <input type="email" id="email" name="email" required placeholder="your.email@example.com" />
            </div>
            <div className="form-group">
              <label htmlFor="message">
                <FaComments className="label-icon" />
                Message
              </label>
              <textarea 
                id="message" 
                name="message" 
                rows="6" 
                required 
                placeholder="Tell us about your question, concern, or how we can help you..."
              ></textarea>
            </div>
            <button type="submit" className="btn btn-primary">
              <FaPaperPlane className="btn-icon" />
              Send Message
              <span className="btn-arrow">→</span>
            </button>
          </form>
        </div>
      </div>

      <div className="info-card faq-card">
        <FaQuestionCircle className="card-icon" />
        <div className="card-content">
          <h2>Quick Help</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Registration Questions?</h4>
              <p>Need help with team registration, entry fees, or category selection? Contact us for assistance.</p>
            </div>
            <div className="faq-item">
              <h4>Sponsorship Opportunities?</h4>
              <p>Interested in becoming a sponsor? We'd love to discuss partnership opportunities with you.</p>
            </div>
            <div className="faq-item">
              <h4>Event Day Information?</h4>
              <p>Questions about schedule, location, amenities, or what to bring? We're here to help!</p>
            </div>
            <div className="faq-item">
              <h4>Kids Cookoff?</h4>
              <p>Need information about the Junior Pitmasters Challenge? Age groups, rules, and prizes info available.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 